module.exports = __webpack_public_path__ + "static/media/package-init-finished.541a0526.png";